import { useQuery } from "react-query";

import { ApiResult } from "../api/apiResult";
import { fetchPlayTo3DDataSources } from "../api/ipdp";

export const PLAY_TO_3D_DATA_SOURCES_QUERY_KEYS = {
  playTo3DDataSources: "fetchPlayTo3DDataSources"
};
///hook to fetch ipdb fields
export default function usePlayTo3DDataSources(): ApiResult<string[]> {
  const { data, isLoading, isError, refetch } = useQuery<string[]>(
    PLAY_TO_3D_DATA_SOURCES_QUERY_KEYS.playTo3DDataSources,
    fetchPlayTo3DDataSources
  );

  return {
    data,
    isLoading,
    isError,
    refetch
  };
}
